(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanlara-bruna-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.van-tabs-products').forEach((section) => {
      const buttons = section.querySelectorAll('[data-van-tabs-button]');
      const panels = section.querySelectorAll('[data-van-tabs-panel]');
      const viewLinks = section.querySelectorAll('[data-van-tabs-view], [data-van-tabs-view-mobile]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const id = button.dataset.vanTabsButton;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const active = panel.dataset.vanTabsPanel === id;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
            if (active) {
              viewLinks.forEach((link) => {
                link.href = panel.dataset.vanTabsUrl || link.href;
              });
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanlara-bruna-home-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('[data-van-banner]').forEach((section) => {
        if (section.dataset.vanBannerReady === 'true') return;
        section.dataset.vanBannerReady = 'true';

        const slides = Array.from(section.querySelectorAll('[data-van-banner-slide]'));
        const dots = Array.from(section.querySelectorAll('[data-van-banner-dot]'));
        const interval = Number(section.style.getPropertyValue('--van-banner-interval').replace('ms', '')) || 5000;
        let index = 0;
        let timer;

        const show = (nextIndex) => {
          if (!slides.length) return;
          index = nextIndex;
          slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
          dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
        };

        const start = () => {
          window.clearInterval(timer);
          if (slides.length > 1) {
            timer = window.setInterval(() => show((index + 1) % slides.length), interval);
          }
        };

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            show(Number(dot.dataset.vanBannerDot) || 0);
            start();
          });
        });

        start();
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanlara-community-inspiration"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      const sections = root.querySelectorAll('.van-community');

      sections.forEach((section) => {
      if (section.dataset.vanCommunityReady === 'true') return;
      section.dataset.vanCommunityReady = 'true';

      const rail = section.querySelector('[data-van-community-rail]');
      if (!rail) return;

      const speed = Number(section.style.getPropertyValue('--van-community-speed')) || 34;
      const autoplay = section.dataset.vanCommunityAutoplay === 'true';
      const looped = rail.dataset.vanCommunityLoop === 'true';
      const cssAnimated = autoplay && looped;
      let paused = false;
      let resumeTimer;
      let lastTime;
      let resetPoint = 0;
      let isDragging = false;
      let dragMoved = false;
      let dragStartX = 0;
      let dragStartTranslate = 0;

      const fillLoop = () => {
        if (!autoplay || !looped || rail.dataset.vanCommunityFilled === 'true') return;
        const originals = Array.from(rail.querySelectorAll('.van-community__tile:not([aria-hidden="true"])'));
        let guard = 0;

        while (rail.scrollWidth < rail.clientWidth * 2.2 && guard < 4) {
          originals.forEach((tile) => {
            const clone = tile.cloneNode(true);
            clone.setAttribute('tabindex', '-1');
            clone.setAttribute('aria-hidden', 'true');
            rail.appendChild(clone);
          });
          guard += 1;
        }

        rail.dataset.vanCommunityFilled = 'true';
      };

      const measure = () => {
        const tiles = rail.querySelectorAll('.van-community__tile');
        const duplicateStart = rail.querySelector('.van-community__tile[aria-hidden="true"]');
        resetPoint = 0;
        if (autoplay && looped && tiles.length > 1) {
          resetPoint = duplicateStart ? duplicateStart.offsetLeft : rail.scrollWidth / 2;
          if (!resetPoint || resetPoint <= rail.clientWidth) resetPoint = rail.scrollWidth / 2;
        }
      };

      const pause = () => {
        paused = true;
        rail.classList.add('is-paused');
        window.clearTimeout(resumeTimer);
      };

      const resumeSoon = () => {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(() => {
          paused = false;
          rail.classList.remove('is-paused');
          rail.style.animation = '';
          rail.style.transform = '';
        }, 2000);
      };

      const currentTranslateX = () => {
        const transform = window.getComputedStyle(rail).transform;
        if (!transform || transform === 'none') return 0;
        const match = transform.match(/matrix.*\((.+)\)/);
        if (!match) return 0;
        const values = match[1].split(',').map((value) => Number(value.trim()));
        return values.length === 16 ? values[12] : values[4] || 0;
      };

      const setManualTranslate = (value) => {
        if (resetPoint > 0) {
          while (value <= -resetPoint) value += resetPoint;
          while (value > 0) value -= resetPoint;
        }
        rail.style.transform = `translate3d(${value}px, 0, 0)`;
      };

      const startDrag = (event) => {
        if (!cssAnimated || event.pointerType === 'mouse') return;
        measure();
        pause();
        isDragging = true;
        dragMoved = false;
        dragStartX = event.clientX;
        dragStartTranslate = currentTranslateX();
        rail.style.animation = 'none';
        setManualTranslate(dragStartTranslate);
        rail.setPointerCapture?.(event.pointerId);
      };

      const drag = (event) => {
        if (!isDragging) return;
        const deltaX = event.clientX - dragStartX;
        if (Math.abs(deltaX) > 4) dragMoved = true;
        setManualTranslate(dragStartTranslate + deltaX);
      };

      const endDrag = (event) => {
        if (!isDragging) return;
        isDragging = false;
        rail.releasePointerCapture?.(event.pointerId);
        resumeSoon();
      };

      const tick = (time) => {
        if (!lastTime) lastTime = time;
        const delta = time - lastTime;
        lastTime = time;

        if (!cssAnimated && autoplay && !paused && rail.scrollWidth > rail.clientWidth) {
          if (!resetPoint) measure();
          rail.scrollLeft += speed * delta / 1000;
          if (resetPoint > 0 && rail.scrollLeft >= resetPoint) {
            rail.scrollLeft = rail.scrollLeft - resetPoint;
          }
        }

        window.requestAnimationFrame(tick);
      };

      fillLoop();
      measure();
      window.setTimeout(measure, 400);
      if ('ResizeObserver' in window) {
        new ResizeObserver(measure).observe(rail);
      } else {
        window.addEventListener('resize', measure);
      }

      rail.addEventListener('scroll', measure, { passive: true });
      rail.addEventListener('pointerdown', startDrag);
      rail.addEventListener('pointermove', drag);
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('click', (event) => {
        if (!dragMoved) return;
        event.preventDefault();
        event.stopPropagation();
        dragMoved = false;
      }, true);
      rail.addEventListener('touchstart', pause, { passive: true });
      rail.addEventListener('touchend', resumeSoon);
      window.requestAnimationFrame(tick);

      section.querySelectorAll('[data-van-community-open]').forEach((button) => {
        button.addEventListener('click', () => {
          const modal = section.querySelector(`[data-van-community-modal="${button.dataset.vanCommunityOpen}"]`);
          if (!modal) return;
          modal.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        });
      });

      section.querySelectorAll('.van-community-modal').forEach((modal) => {
        const close = () => {
          modal.hidden = true;
          document.documentElement.style.overflow = '';
        };

        modal.querySelector('[data-van-community-close]')?.addEventListener('click', close);
        modal.addEventListener('click', (event) => {
          if (event.target === modal) close();
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !modal.hidden) close();
        });
      });
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
